import { render, staticRenderFns } from "./DetalhamentoCarrinhosProduto.vue?vue&type=template&id=95fbfe4a&scoped=true"
import script from "./DetalhamentoCarrinhosProduto.vue?vue&type=script&lang=js"
export * from "./DetalhamentoCarrinhosProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fbfe4a",
  null
  
)

export default component.exports